import { COLORS } from '../../config/designSystem/Colors';
import { FlatList, View } from 'react-native';
import { Fragment } from 'react';
import { SPACING } from '../../config/designSystem/Spacing';



interface DotsProps  {
    nbElements: number
    indexSelected: number
}

export const Dots = ({nbElements, indexSelected}: DotsProps) => {
  if(nbElements <= 1 || indexSelected> nbElements) {
    return <></>;
  }
  const elements = Array(nbElements).fill(false);
  elements[indexSelected] = true;

  const WIDTH = SPACING['sp-8'];
  const MARGIN = SPACING['sp-4'];


  return (
    <>
      <FlatList
        data={elements}
        horizontal={true}
        scrollEnabled={false}
        snapToInterval={WIDTH + 2*MARGIN}
        showsHorizontalScrollIndicator={false}
        renderItem={({item, index}) => {

          return(
            <Fragment key={index}>
              <View style={{
                width: WIDTH,
                height: WIDTH,
                borderRadius: WIDTH/2,
                backgroundColor: COLORS.surface['primary-dark'],
                opacity: item ? 1 : 0.2,
                marginHorizontal: MARGIN
              }} />
            </Fragment>);
        }}

        keyExtractor={(item, index) => index.toString()}
      />
    </>
  );
};

